import React from 'react';

/**
 * Botão de ícone reutilizável — estilo quadrado arredondado, colorido, somente ícone.
 * Baseado no padrão visual do sistema (botões compactos com ícones brancos).
 *
 * Variantes de cor por tipo de ação:
 * - primary (azul): Novo, Salvar, Buscar
 * - warning (âmbar): Editar
 * - danger (vermelho): Excluir
 * - success (verde): Importar, Exportar
 * - purple (roxo): Consolidar, Arquivar
 * - info (ciano): Visualizar
 * - secondary (cinza): Cancelar, Fechar
 */
const variants = {
  primary: 'bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white',
  warning: 'bg-amber-500 hover:bg-amber-600 active:bg-amber-700 text-white',
  danger: 'bg-red-600 hover:bg-red-700 active:bg-red-800 text-white',
  success: 'bg-green-600 hover:bg-green-700 active:bg-green-800 text-white',
  purple: 'bg-purple-600 hover:bg-purple-700 active:bg-purple-800 text-white',
  info: 'bg-cyan-500 hover:bg-cyan-600 active:bg-cyan-700 text-white',
  secondary: 'bg-gray-400 hover:bg-gray-500 active:bg-gray-600 text-white'
};

const sizes = {
  xs: 'w-5 h-5',
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12'
};

const iconSizes = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6'
};

const IconButton = React.forwardRef(({
  icon: Icon,
  onClick,
  variant = 'primary',
  size = 'md',
  title,
  disabled = false,
  className = '',
  type = 'button',
  ...rest
}, ref) => {
  return (
    <button
      ref={ref}
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
      className={`inline-flex items-center justify-center rounded-lg font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
      {...rest}
    >
      {Icon && <Icon className={iconSizes[size] || iconSizes.md} />}
    </button>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
